import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { required } from "../utility";
import { MaterialTextField } from "./MaterialInput";
import SubmitButton from './SubmitButton';
import Paper from '@material-ui/core/Paper';

class editStats extends React.Component {
    render() {
        const { clientId, onEditStats, handleSubmit } = this.props;
        return (
            <Paper className="common-paper m20">
                <form className="common-form common-column" onSubmit={handleSubmit(data => onEditStats(clientId, data))} >
                    <Field component={MaterialTextField}
                           validate={required}
                           name="clientCarsLength"
                           label="Всего обращений" />
                    <Field component={MaterialTextField}
                           validate={required}
                           name="clientCarsClosedLength"
                           label="Закрыте договоры" />
                    <SubmitButton label="Сохранить" />
                </form>
            </Paper>
        );
    }
}

const EditStats = connect(
    (state, props) => {
        const { clientCarsLength, clientCarsClosedLength } = props;
        return {
            initialValues: {
                clientCarsLength,
                clientCarsClosedLength
            },
        };
    },
    null
)(reduxForm({ form: "edit-stats-form" })(editStats));

export default EditStats;



// WEBPACK FOOTER //
// ./src/components/EditStats.js